import { isEqual, parseISO, isSameMonth, isToday, format } from "date-fns"

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const SmallMonthViewCalendar = ({selectedDay, dayObject, firstDayOfCurrentMonth}) => {
    return(
        <div className="isolate grid w-full grid-cols-7 grid-rows-6 gap-px lg:hidden hidden">
        {Object.keys(dayObject).map((day) => (
          <button
            key={day.toString()}
            type="button"
            className={classNames(
              isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) ? 'bg-white' : 'bg-gray-50',
              (isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) || isToday(parseISO(day, 'yyyy-MM-dd'))) && 'font-semibold',
              isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && 'text-white',
              !isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-indigo-600',
              !isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-gray-900',
              !isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && !isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-gray-500',
              'flex h-14 flex-col py-2 px-3 hover:bg-gray-100 focus:z-10'
            )}
          >
            <time
              dateTime={day}
              className={classNames(
                isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && 'flex h-6 w-6 items-center justify-center rounded-full',
                isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && isToday(parseISO(day, 'yyyy-MM-dd')) && 'bg-indigo-600',
                isEqual(parseISO(day, 'yyyy-MM-dd'), selectedDay) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'bg-gray-900',
                'ml-auto'
              )}
            >
              {format(parseISO(day, 'd'), 'd')}
            </time>
            <span className="sr-only">{dayObject[day].events.length > 0 && dayObject[day].events.length} events</span>
            <span className="sr-only">{dayObject[day].events.length}</span>
            {dayObject[day].events.length > 0 && (
              <span className="-mx-0.5 mt-auto flex flex-wrap-reverse">
                {dayObject[day].events.map((event) => (<span key={event.id} className="mx-0.5 mb-1 h-1.5 w-1.5 rounded-full bg-gray-400" />))}
              </span>
            )}
          </button>
        ))}
      </div>
    )
}
export default SmallMonthViewCalendar